var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 286,
    viewBox: "0 0 460 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9806_207765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 249.267H44.4825",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5929 231.551L50.672 238.63",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9721 231.551L67.8931 238.63",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5303 224.459V235.096",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.534 1.27093H164.001V259.892H353.534V1.27093Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.83 47.3294H181.717V107.559H335.83V47.3294Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.421 65.0334V91.6086",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.763 65.0334V91.6086",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.592 65.0334V91.6086",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.83 114.638H181.717V174.867H335.83V114.638Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.421 132.355V158.917",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.763 132.355V158.917",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.592 132.355V158.917",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.83 181.946H181.717V242.175H335.83V181.946Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.421 199.663V226.238",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.763 199.663V226.238",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.592 199.663V226.238",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.076 20.7543H335.818",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.717 20.7543H201.201",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.369 227.115C395.828 227.115 394.289 227.238 392.768 227.484C389.78 219.24 384.326 212.118 377.147 207.084C369.968 202.05 361.413 199.35 352.645 199.35C343.877 199.35 335.322 202.05 328.143 207.084C320.964 212.118 315.509 219.24 312.521 227.484C308.594 226.838 304.574 227.014 300.718 228C296.862 228.987 293.252 230.763 290.116 233.215C286.981 235.668 284.388 238.744 282.502 242.249C280.616 245.754 279.478 249.613 279.158 253.581C278.839 257.548 279.346 261.539 280.648 265.301C281.949 269.063 284.017 272.514 286.72 275.436C289.423 278.358 292.703 280.688 296.352 282.278C300.001 283.869 303.94 284.685 307.921 284.675H397.369C405.003 284.675 412.325 281.642 417.724 276.244C423.122 270.845 426.155 263.523 426.155 255.889C426.155 248.254 423.122 240.932 417.724 235.534C412.325 230.135 405.003 227.102 397.369 227.102V227.115Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.876 236.609L367.705 263.425",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.876 263.425L367.705 236.609",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 122.581H390.734V145.674H460V122.581Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 96.921H390.734V120.014H460V96.921Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 148.228H390.734V171.321H460V148.228Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.274 112.325C404.401 112.325 406.125 110.601 406.125 108.474C406.125 106.347 404.401 104.623 402.274 104.623C400.148 104.623 398.423 106.347 398.423 108.474C398.423 110.601 400.148 112.325 402.274 112.325Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.098 112.325C417.225 112.325 418.949 110.601 418.949 108.474C418.949 106.347 417.225 104.623 415.098 104.623C412.971 104.623 411.247 106.347 411.247 108.474C411.247 110.601 412.971 112.325 415.098 112.325Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.274 137.972C404.401 137.972 406.125 136.248 406.125 134.121C406.125 131.994 404.401 130.27 402.274 130.27C400.148 130.27 398.423 131.994 398.423 134.121C398.423 136.248 400.148 137.972 402.274 137.972Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.098 137.972C417.225 137.972 418.949 136.248 418.949 134.121C418.949 131.994 417.225 130.27 415.098 130.27C412.971 130.27 411.247 131.994 411.247 134.121C411.247 136.248 412.971 137.972 415.098 137.972Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.274 163.632C404.401 163.632 406.125 161.908 406.125 159.781C406.125 157.654 404.401 155.93 402.274 155.93C400.148 155.93 398.423 157.654 398.423 159.781C398.423 161.908 400.148 163.632 402.274 163.632Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.098 163.632C417.225 163.632 418.949 161.908 418.949 159.781C418.949 157.654 417.225 155.93 415.098 155.93C412.971 155.93 411.247 157.654 411.247 159.781C411.247 161.908 412.971 163.632 415.098 163.632Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.693 27.9604C220.554 27.9604 223.683 24.8309 223.683 20.9703C223.683 17.1098 220.554 13.9802 216.693 13.9802C212.833 13.9802 209.703 17.1098 209.703 20.9703C209.703 24.8309 212.833 27.9604 216.693 27.9604Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.95 68.9733H142.344C135.603 68.9733 129.137 71.6513 124.37 76.4182C119.604 81.1851 116.926 87.6505 116.926 94.3919V223.849C116.926 230.59 114.248 237.055 109.481 241.822C104.714 246.589 98.2484 249.267 91.5069 249.267H71.439",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9806_207765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 285.959,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server_error.ca71f36f8df7793fb602f5b73c3ede5c.svg";
export { ForwardRef as ReactComponent };